import store from '@/store';
import Vue from 'vue';
import api from '@/api/certificate';

export default {
  namespaced: true,
  actions: {
    sendCodeBySMS() {
      store.dispatch('application/startLoading');
      return api.sendCodeBySMS()
        .then((response) => {
          if (response.status === 'success') {
            store.dispatch('application/displaySnackbar', {
              text: Vue.$i18n.t('store.certificate.sms.success'),
              time: 3,
              type: 'success',
            });
            return Promise.resolve(response.data);
          }
          return Promise.reject(response);
        })
        .catch((error) => {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.certificate.sms.error'),
            time: 3,
            type: 'error',
          });
          return Promise.reject(error);
        })
        .finally(() => {
          store.dispatch('application/finishLoading');
        });
    },
    sendCodeByEmail() {
      store.dispatch('application/startLoading');
      return api.sendCodeByEmail()
        .then((response) => {
          if (response.status === 'success') {
            store.dispatch('application/displaySnackbar', {
              text: Vue.$i18n.t('store.certificate.email.success'),
              time: 3,
              type: 'success',
            });
            return Promise.resolve(response.data);
          }
          return Promise.reject(response);
        })
        .catch((error) => {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.certificate.email.error'),
            time: 3,
            type: 'error',
          });
          return Promise.reject(error);
        })
        .finally(() => {
          store.dispatch('application/finishLoading');
        });
    },
    sendCodeByPhone() {
      store.dispatch('application/startLoading');
      return api.sendCodeByPhone()
        .then((response) => {
          if (response.status === 'success') {
            store.dispatch('application/displaySnackbar', {
              text: Vue.$i18n.t('store.certificate.phone.success'),
              time: 3,
              type: 'success',
            });
            return Promise.resolve(response.data);
          }
          return Promise.reject(response);
        })
        .catch((error) => {
          store.dispatch('application/displaySnackbar', {
            text: Vue.$i18n.t('store.certificate.phone.error'),
            time: 3,
            type: 'error',
          });
          return Promise.reject(error);
        })
        .finally(() => {
          store.dispatch('application/finishLoading');
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/certificate/index.js